/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="12"
        height="32"
        viewBox="0 0 12 32"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          stroke="#4a4a4a"
          d="m1.137 1 8.88 15.873L1.136 30.1"
          style={{ fill: 'none' }}
          className="icon-stroke"
          strokeWidth="2"
          strokeLinecap="round"/>
      </svg>

    );
  }
}

Icon.displayName = 'ChevronRightNarrowIcon';

export default Icon;
